module.exports = __webpack_public_path__ + "img/icon_celect_delete.68c146d9.svg";